import { render, staticRenderFns } from "./selectMutiShop.vue?vue&type=template&id=61b26a18"
import script from "./selectMutiShop.vue?vue&type=script&lang=js"
export * from "./selectMutiShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports